import styled from "@emotion/styled";
import CheckboxComponent from "@components/form/Checkbox";
import { theme } from "@styles/theme";
import TextFieldComponent from "@components/form/TextField";
const { md, lg } = theme.breakpoints;
/*export const Container = styled.div`
  display: flex;
  align-items: baseline;
  margin-bottom: 1em;
  @media (max-width: ${md}) {
    flex-direction: column;
  }
`;*/
/* export const Container = styled.div`
  display: grid;
  grid-template-columns: 9ch repeat(6, minmax(0, 1fr));
  margin-bottom: 3em;
  column-gap: 1em;
  row-gap: 2em;
  align-items: center;
  grid-template-areas:
    "title  eps          eps         ips         ips eapb eapb"
    ".      territorial  territorial territorial si  si  si"
    ".      other        other       other       other    .   ."
    "error      error       .       .       .    .   .";
  @media (max-width: ${md}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-areas:
      "title title"
      "eps ips"
      "eapb eapb"
      "territorial territorial"
      "si si"
      "other other"
      "error error";
  }
`; */

export const Container = styled.div`
  display: flex;
`;
export const FromGroup = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 2em;
  max-width: 200px;
  margin-right: 2em;
`;
export const Area = styled.div`
  grid-area: ${({ name }: { name: string }) => name};
`;
export const Entity = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  flex-wrap: wrap;
  font-size: 1em;
  @media (max-width: ${lg}) {
    width: 100%;
  }
  @media (max-width: ${md}) {
    flex-direction: column;
  }
`;
export const LabelEntity = styled.div`
  color: #6d6d6d;
  font-family: Poppins Regular;
  font-size: 1em;
`;
export const LabelOption = styled.div`
  white-space: nowrap;
  margin-right: 1em;
`;
export const TextField = styled(TextFieldComponent)`
  width: 100%;
  font-size: 0.9em;
  border-radius: 0.3em;
`;
export const TextFieldEmpty = styled.input`
  font-size: 1rem;
  font-family: Poppins Regular;
  border: solid #a2a2a2 1px;
  border-radius: 0.5em;
  padding: 0.5em;
  text-align: center;
  box-sizing: border-box;
  width: 100%;
  font-size: 0.9em;
  border-radius: 0.3em;
`;
export const Checkbox = styled(CheckboxComponent)`
  font-size: 1em;
  width: 100%;
  justify-content: flex-start;
  font-family: Poppins Ligth;
  align-items: center;
  /*:last-of-type {
    flex-grow: 2;
  }
  @media (max-width: ${lg}) {
    width: 33%;
    :nth-last-of-type(2) {
      flex-grow: 1;
    }
  }
  @media (max-width: ${md}) {
    width: 100%;
    ${TextField} {
      flex-grow: 1;
    }
    :last-of-type {
      ${TextField} {
        width: 50%;
      }
    }
  }*/
`;
export const InputContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`;
const color = "#f8f8f8";
export const stylesSelect = {
  container: (base: any) => ({
    ...base,
    width: "100%",
    // marginTop: "0.5em",
    boxSizing: "border-box",
  }),
  control: (base: any, state: any) => ({
    ...base,
    backgroundColor: color,
    borderColor: state.isFocused ? "#a2a2a2" : "#a2a2a2",
    boxShadow: state.isFocused ? "#a2a2a2" : "#a2a2a2",
    "&:hover": {
      borderColor: state.isFocused ? "#a2a2a2" : "#a2a2a2",
      boxShadow: state.isFocused ? "#a2a2a2" : "#a2a2a2",
    },
    height: "2em",
    minHeight: 0,
    borderRadius: "0.5em",
    paddingLeft: "1em",
    textAlign: "center",
  }),
  valueContainer: (_base: any) => ({
    alignSelf: "baseline",
  }),
  indicatorSeparator: (base: any) => ({
    ...base,
    display: "none",
  }),
  singleValue: (base: any) => ({
    ...base,
    color: "#a8a8a8",
    fontFamily: "Poppins ExtraLight",
    fontSize: "0.9em",
  }),
  dropdownIndicator: (_base: any) => ({
    padding: "0 8px",
  }),
};
export const Error = styled.div`
  position: absolute;
  grid-area: error;
  font-family: Poppins Ligth;
  color: red;
`;
